module.exports = "/cyber/_next/static/images/globe-3c36fb9d8eb46048109e2000c49330b1.png";